import { useEffect } from 'react';

interface MetaConfig {
  title: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
}

function setOrCreateMeta(name: string, attr: 'name' | 'property', content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setOrCreateLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useDocumentMeta({ title, description, canonical, ogImage }: MetaConfig) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    if (description) {
      setOrCreateMeta('description', 'name', description);
      setOrCreateMeta('og:description', 'property', description);
    }
    setOrCreateMeta('og:title', 'property', title);
    setOrCreateMeta('og:type', 'property', 'website');
    if (canonical) {
      setOrCreateLink('canonical', canonical);
      setOrCreateMeta('og:url', 'property', canonical);
    }
    if (ogImage) {
      setOrCreateMeta('og:image', 'property', ogImage);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, canonical, ogImage]);
}
